module.exports = __webpack_public_path__ + "img/img2.3d433c2b.jpg";